import React, { Fragment, useState } from "react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";



import { Button, Typography } from "@mui/material";
import { set } from "date-fns";
//import { useHistory } from "react-router-dom";

//handle submit


export default function SendPasswordLink() {
  const [message, setMessage] = useState("");
  function handleSubmit() {

    //Get data from form
    const email = document.getElementById("email").value;

    //send data to server
    //console.log("email: " + email + " password: " + password);
    //post data to server
    fetch("/user/sendPasswordLink", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: email }),
    })
      .then((response) => response.json())
      .then((data) => {
        //  debugger;
        console.log(data);
        //if login is successful, redirect to dasboard page

        if (data.length > 0) {
          setMessage(data);
        }
        else {
          //show error message
          alert("Invalid email or password");
        }
      });

  };
  return (

    //Login form
    <Fragment>
      <h2>Reset Password</h2>
      <form>
        <Grid container spacing={1}>
        <Grid item xs={12} sm={12}>
            <Typography variant="body2" color="text.secondary" >
              Enter your email address and we will send you a link to reset your password.
            </Typography>
          </Grid>
          <Grid item xs={4} sm={4}>
            <TextField
              id="email"
              label="Email"
              variant="outlined"
              fullWidth
              required
              placeholder="A link will be sent to your email to reset your password"
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <Typography variant="body2" color="text.secondary" >

            </Typography>
          </Grid>
          {/* <Grid item xs={4} sm={4}>
            <TextField
              id="password"
              label="Password"
              variant="outlined"
              fullWidth
              required
            />
          </Grid> */}
          <Grid item xs={1} sm={1}>
        <Button color="primary" variant="outlined" onClick={handleSubmit}>Send Link</Button>
      </Grid>
      <Grid item xs={8} sm={8} >
        <Typography variant="body2" color="green" style={{ textAlign: 'left',paddingTop: '10px' }} >
          {message}
        </Typography>
      </Grid>

        </Grid>

      </form>

      
    </Fragment>
  );
}
